// extracted by mini-css-extract-plugin
export default {"container":"nhl-mvp-footer_container__2HW0U","normandin":"nhl-mvp-footer_normandin__3FlGE"};